import api from '..'

const canView = () => {
  return api
    .get('/integrations/tenants/access')
    .then(({ data }) => data)
    .catch(() => {
      window.location.href = process.env.REACT_APP_LOGIN_URL as string
    })
}

export default canView
